var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0007 10.6667V2.66667C19.0007 1.2 17.8007 0 16.334 0H8.33398C6.86732 0 5.66732 1.2 5.66732 2.66667V5.33333H3.00065C1.53398 5.33333 0.333984 6.53333 0.333984 8V21.3333C0.333984 22.8 1.53398 24 3.00065 24H9.66732C10.4007 24 11.0007 23.4 11.0007 22.6667V18.6667H13.6673V22.6667C13.6673 23.4 14.2673 24 15.0007 24H21.6673C23.134 24 24.334 22.8 24.334 21.3333V13.3333C24.334 11.8667 23.134 10.6667 21.6673 10.6667H19.0007ZM5.66732 21.3333H3.00065V18.6667H5.66732V21.3333ZM5.66732 16H3.00065V13.3333H5.66732V16ZM5.66732 10.6667H3.00065V8H5.66732V10.6667ZM11.0007 16H8.33398V13.3333H11.0007V16ZM11.0007 10.6667H8.33398V8H11.0007V10.6667ZM11.0007 5.33333H8.33398V2.66667H11.0007V5.33333ZM16.334 16H13.6673V13.3333H16.334V16ZM16.334 10.6667H13.6673V8H16.334V10.6667ZM16.334 5.33333H13.6673V2.66667H16.334V5.33333ZM21.6673 21.3333H19.0007V18.6667H21.6673V21.3333ZM21.6673 16H19.0007V13.3333H21.6673V16Z",
    fill: "#2E2B2E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnit);
export default __webpack_public_path__ + "static/media/unit.8cc5a675d87017b2fa8a742fd22a4b74.svg";
export { ForwardRef as ReactComponent };